import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import SingleItem from "./SingleItem";
import CustomPagination from "../../../CustomPagination/CustomPagination";

const UserOrderList = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [paginateData, setPaginateData] = useState({});
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);

        const response = await axios.get(
          `https://api.velormall.com/api/admin/order/user/assign/view/${id}`
        );

        setData(response?.data?.data || []);
        setPaginateData(response?.data || {});
      } catch (error) {
        console.error("Failed to fetch orders:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchOrders();
    }
  }, [id]);

  const handlePage = async (event) => {
    try {
      const pageNumber = event?.selected + 1;

      const response = await axios.get(
        `https://api.velormall.com/api/admin/order/user/assign/view/${id}?page=${pageNumber}`
      );

      setData(response?.data?.data || []);
      setPaginateData(response?.data || {});
    } catch (error) {
      console.error("Pagination error:", error);
    }
  };

  return (
    <div className="mt-30">
      <div className="card">
        <div className="card-body">
          <div className="d-flex mb-2 flex-wrap gap-3 justify-content-between align-items-center">
            <h6 className="page-title">Order Lists</h6>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="card b-radius--10">
                <div className="card-body p-0">
                  <div className="table-responsive--md table-responsive">
                    <table className="table table--light style-two mb-0">
                      <thead>
                        <tr>
                          <th>S.N</th>
                          <th>Type</th>
                          <th>Order #</th>
                          <th>Manage Crypto</th>
                          <th>Order Amount</th>
                          <th>Profit %</th>
                          <th>Profit Amount</th>
                          <th>Total With Profit</th>
                          <th>Status</th>
                        </tr>
                      </thead>

                      <tbody>
                        {loading ? (
                          <tr>
                            <td
                              colSpan="9"
                              className="text-center text-muted"
                            >
                              Loading orders...
                            </td>
                          </tr>
                        ) : data.length > 0 ? (
                          data.map((item, index) => (
                            <SingleItem
                              key={item._id}
                              data={item}
                              index={index}
                            />
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="9"
                              className="text-center text-muted"
                            >
                              Data not found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* paginateLinks */}
                <CustomPagination
                  data={paginateData}
                  handlePage={handlePage}
                ></CustomPagination>
                {/* paginateLinks */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserOrderList;